import { Container } from '@/components/layout/PublicLayout';
import { PageHeading } from '@/components/ui/Feedback';
import { useI18n } from '@/contexts/I18n';

export function NotFoundPage() {
  const { t } = useI18n();
  return (
    <Container>
      <PageHeading title={t.common.notFound} />
    </Container>
  );
}
